import { getValidClassNames } from "@/utils"
import { IReactChildren } from "@netfront/common-library"
import { Button, ButtonProps, IAdditionalClassNames } from "@netfront/ui-library"

export interface BannerProps extends IAdditionalClassNames, IReactChildren {
  actions?: ButtonProps[];
  title?: string;
};

export const Banner = ({ actions, additionalClassNames, children, title }: BannerProps) => {
  return(
    <div
      className={getValidClassNames({
        'bg-primary bg-banner-graphic rounded-xl p-8 md:p-12 mb-12': true,
        [String(additionalClassNames)]: Boolean(additionalClassNames),
      })}
    >
      {title && (
        <h2 className="h2 mb-2">{title}</h2>
      )}

      {children}

      {actions && (
        <div className="flex items-center justify-end mt-4">
          {actions.map((buttonProps, index) => (
            <Button {...buttonProps} key={`banner-action-${index}`} />
          ))}
        </div>
      )}

    </div>
  )
}